module.exports = "<main role=\"main\">\n  <h2 class=\"text-title\">Linha do Tempo</h2>\n  <div class=\"timeline\">\n    <div class=\"containertm\" [ngClass]=\"{'left': i%2==0, 'right': i%2!=0}\" *ngFor=\"let item of itens | async ; index as i\">\n      <div class=\"contenttm\">\n        <h2 class=\"text-title\">{{item.periodo}}</h2>\n        <h3>{{item.titulo}}</h3>\n        <p class=\"lead text-justify\" [innerHTML]=\"item.descricao\"></p>\n      </div>\n    </div>\n  </div>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/timeline/timeline.component.html
// module id = ./src/app/timeline/timeline.component.html
// module chunks = main